import type { ImgSet } from "../components/Picture";

const avif1200 = import.meta.glob<string>(
  "../../../../attached_assets/jands-drive/suppliers/avif-1200/*.avif",
  { eager: true, import: "default", query: "?url" }
);
const avif600 = import.meta.glob<string>(
  "../../../../attached_assets/jands-drive/suppliers/avif-600/*.avif",
  { eager: true, import: "default", query: "?url" }
);
const webp1200 = import.meta.glob<string>(
  "../../../../attached_assets/jands-drive/suppliers/webp-1200/*.webp",
  { eager: true, import: "default", query: "?url" }
);
const webp600 = import.meta.glob<string>(
  "../../../../attached_assets/jands-drive/suppliers/webp-600/*.webp",
  { eager: true, import: "default", query: "?url" }
);
const jpg1200 = import.meta.glob<string>(
  "../../../../attached_assets/jands-drive/suppliers/jpg-1200/*.jpg",
  { eager: true, import: "default", query: "?url" }
);

function lookup(map: Record<string, string>, suffixed: string): string {
  const hit = Object.entries(map).find(([k]) => k.endsWith("/" + suffixed));
  if (!hit) {
    throw new Error(`supplierImages: missing asset matching '${suffixed}'`);
  }
  return hit[1];
}

export function supplierImg(baseName: string): ImgSet {
  return {
    avif1200: lookup(avif1200, `${baseName}-1200.avif`),
    avif600: lookup(avif600, `${baseName}-600.avif`),
    webp1200: lookup(webp1200, `${baseName}-1200.webp`),
    webp600: lookup(webp600, `${baseName}-600.webp`),
    fallback: lookup(jpg1200, `${baseName}-1200.jpg`),
  };
}
